import React from 'react';
import { motion } from 'framer-motion';
export function HowItWorksSection() {
  const steps = [{
    num: '01',
    title: 'Detectar',
    desc: 'Identificas la ventana biológica de sueño usando el radar visual.'
  }, {
    num: '02',
    title: 'Preparar',
    desc: 'Blindas el entorno sensorial (luz y ruido blanco) para evitar micro-despertares.'
  }, {
    num: '03',
    title: 'Transferir',
    desc: 'Ejecutas el protocolo de 3 pasos (Lado-Espalda-Presión) para dejar al bebé en la cuna en <10 minutos.'
  }];
  return <section className="bg-cream py-24 px-6" data-id="element-135">
      <div className="max-w-5xl mx-auto" data-id="element-136">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-137">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-navy mb-4" data-id="element-138">
            Cómo funciona
          </h2>
          <div className="w-16 h-1 bg-gold mx-auto rounded-full" data-id="element-139"></div>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-140">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-1/6 right-1/6 h-0.5 bg-gold/30 z-0" data-id="element-141"></div>

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="relative z-10 flex flex-col items-center text-center" data-id="element-142">
              <div className="w-24 h-24 rounded-full bg-navy text-gold flex items-center justify-center text-3xl font-serif font-bold mb-6 shadow-xl border-4 border-cream" data-id="element-143">
                {step.num}
              </div>
              <h3 className="text-2xl font-bold text-navy mb-3" data-id="element-144">
                {step.title}
              </h3>
              <p className="text-navy/70 leading-relaxed" data-id="element-145">{step.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}